import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import { useApiGet } from '../../hooks';
import { parsers } from '../api';
import ProfileContext from './ProfileContext';
export default (function (_ref) {
  var children = _ref.children;

  var _useApiGet = useApiGet({
    path: '/profile/',
    parse: parsers.parseProfile
  }),
      _useApiGet2 = _slicedToArray(_useApiGet, 1),
      data = _useApiGet2[0];

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      profile = _useState2[0],
      setProfile = _useState2[1];

  useEffect(function () {
    return data && setProfile(data);
  }, [data]);
  return React.createElement(ProfileContext.Provider, {
    value: {
      profile: profile,
      setProfile: setProfile
    }
  }, children);
});